import ExcelJS from 'exceljs';

/**
 * Monta o workbook de exportação de peças (Conversor STEP) usado por
 * StepConverter.jsx. Extraído para função pura testável sem precisar
 * renderizar o componente — ver docs/dividas/auditoria-seguranca.md
 * (achado A10: substitui `xlsx`, sem fix disponível para os CVEs de
 * prototype pollution/ReDoS, por `exceljs`).
 */
export async function gerarWorkbookPecas(pecas) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Peças');
  worksheet.addRow(['Peça', 'Comprimento', 'Largura', 'Altura']);
  pecas.forEach(peca => {
    worksheet.addRow([peca.nome, peca.comprimento, peca.largura, peca.espessura]);
  });
  return workbook;
}
